import React, { useState } from "react";
import Button from '../../../../components/UI/button/button';
import styles from './styles.module.scss';

function LoansPaidoffCardComponent({createRecurrent, device }) {
  const [loading, setLoading] = useState(false);
  const onRequestNewClick = () => {
    setLoading(true);
    createRecurrent(device).then(() => setLoading(false));
  }
  return (
    <div className={styles.loansPaidoffCard}>
        <img className={styles.paidImage} src="/image/ic_quitado.png" alt="Empréstimo Quitado" />
        <p className={`${styles.loansPaidoffCardTitle} mt-4`}>
          Seus empréstimos <br /> <span>estão quitados!</span>
        </p>
        <div className={`${styles.loansPaidoffCardButton} mt-4`}>
          <Button
            id="btRequestNew"
            disabled={loading}
            onClick={onRequestNewClick}
            loading={loading}
            minWidth={300}
          >
            Consultar nova oferta
          </Button>
        </div>
        <div className={`${styles.loansPaidoffCardTerms} mt-4`} target="_blank">
          Ao continuar você concorda com <a href="https://www.supersim.com.br/termos/condicoes/" target="_blank">termos de uso</a>
        </div>
      </div>
  );
}

export { LoansPaidoffCardComponent };
